export default "__VITE_ASSET__Dj1KLdd9__"